'use client';

import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import ROUTES from '@/lib/constants/routeConfig';
import { useUser } from '@/lib/hooks';
import { getInitials, isValidUrl } from '@/lib/utils';
import { useI18n } from '@/locales/client';
import { Button } from '@/components/common/inputs/button/button';
import { ChevronLeft } from 'lucide-react';

type Props = {
  toggleSidebar?: () => void;
};

export const UserSidebarInterface = React.memo(({ toggleSidebar }: Props) => {
  const { user } = useUser();
  const t = useI18n();

  return (
    <div className='flex cursor-pointer items-center justify-between space-x-1 bg-muted font-medium shadow-lg shadow-gray-200 transition-all hover:bg-purple-500 hover:opacity-90 dark:bg-gray-900/30 dark:shadow-none dark:hover:bg-purple-700'>
      <Link
        href={ROUTES.USERPROFILE}
        prefetch={true}
        className='flex items-center space-x-4'
      >
        <div className='relative h-12 w-12 overflow-hidden rounded-r-xl opacity-90 shadow-sm'>
          {user?.avatar && isValidUrl(user.avatar) ? (
            <Image
              fill
              style={{ objectFit: 'cover' }}
              sizes='(max-width: 768px) 10vw, (max-width: 1200px) 50vw, 33vw'
              src={user.avatar}
              priority
              alt='Your avatar'
            />
          ) : (
            <div className='flex h-full w-full items-center justify-center bg-purple-600 text-base font-semibold text-white dark:bg-purple-700'>
              {getInitials(user?.name || '')}
            </div>
          )}
        </div>
        <span className='text-foreground dark:text-gray-100'>{user?.name}</span>
      </Link>
      {/* {toggleSidebar && (
        <Button
        className='hidden'
          onClick={() => {
            toggleSidebar();
          }}
        >
          <ChevronLeft className='h-5 w-5' />
        </Button>
      )} */}
    </div>
  );
});

UserSidebarInterface.displayName = 'UserSidebarInterface';
